import { WidgetDefinition } from '../../models/WidgetDefinition';

export const QualityBadActorsWidgetDefinition: WidgetDefinition = {
    baseType: 'qualityBadActors',
    group: 'Quality',
    highlights: [''],
    icon: 'fa-bar-chart horizontal-bar-chart-miniature',
    sortingOrder: 0,
    title: '',
    type: 'qualityBadActors'
};